import type { ComponentType } from 'react';
import type { HighlightCard } from '@/lib/api-client';

export type SlideRole = 'cover' | 'body' | 'summary';
export type TemplateVariant = 'full' | 'thumbnail';

export interface SlideLayoutProps {
  card: HighlightCard;
  slideIndex: number;
  totalSlides: number;
  conceptName?: string;
}

export interface HighlightTemplate {
  id: string;
  name: string;
  containerClassName?: string;
  layouts: {
    cover: ComponentType<SlideLayoutProps>;
    body: ComponentType<SlideLayoutProps>;
    summary: ComponentType<SlideLayoutProps>;
  };
  // Optional miniature layout for thumbnails / bento tiles / preview cards.
  // Falls back to the cover layout if not provided.
  thumbnail?: ComponentType<SlideLayoutProps>;
}

export function resolveSlideRole(
  slideIndex: number,
  totalSlides: number
): SlideRole {
  if (totalSlides <= 1) return 'cover';
  if (slideIndex === 0) return 'cover';
  if (slideIndex === totalSlides - 1) return 'summary';
  return 'body';
}
